














import { defineComponent, ref, toRef, watch } from "@vue/composition-api";

export default defineComponent({
  name: "FontRange",
  props: {
    currentTextSize: { type: Number, required: true },
  },
  setup(props, { emit }) {
    const rangeValue = ref(props.currentTextSize);

    const changeRange = () => {
      emit("textSize", Number(rangeValue.value));
    };

    watch(toRef(props, "currentTextSize"), newValue => (rangeValue.value = newValue));

    return {
      rangeValue,
      changeRange,
    };
  },
});
